import { GameID, GameIDType } from '@/enums/gameId';

export const gamesWithManyBetsOptions: GameIDType[] = [
  GameID.Double,
  GameID.Frost,
  GameID.CrashTrenball,
];
